import type { ReactNode } from "react";
import type { GridProps } from "@mui/material";
import { Typography, Stack, Checkbox, Grid } from "@mui/material";
import { PerimetreBox } from "components/Business";
import type { Perimetre } from "models";

interface RecapitulatifDeselectionnablePerimetreProps extends GridProps {
  perimetres?: Array<Partial<Perimetre>>;
  onPerimetreChange: (perimetres: Array<Perimetre>) => void;
}

export function RecapitulatifDeselectionnablePerimetre({
  perimetres,
  onPerimetreChange: onChange,
  ...gridProps
}: Readonly<RecapitulatifDeselectionnablePerimetreProps>): ReactNode {
  if (perimetres == null || perimetres.length === 0) return null;

  return (
    <Grid container size={12} spacing={2} {...gridProps}>
      <Typography component={Grid} size={12}>
        Récapitulatif des périmètres sélectionnés :
        <br />
        <Typography component="span" variant="caption" color="text.secondary">
          Cliquez sur un périmètre pour le retirer de la sélection
        </Typography>
      </Typography>

      <Stack spacing={0}>
        {perimetres?.map((p) => (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            key={p.id}
            onClick={() => {
              onChange(((perimetres ?? []) as Array<Perimetre>).filter((per) => per.id !== p.id));
            }}
            sx={{ cursor: "pointer" }}>
            <Checkbox checked size="small" sx={{ p: 0.5 }} />
            <PerimetreBox perimetre={p as Perimetre} />
          </Stack>
        ))}
      </Stack>
    </Grid>
  );
}
